<template>
    <article class="mx-auto grid w-full max-w-3xl gap-6 text-left">
        <Link href="/stories" class="group inline-flex w-fit items-center gap-1 text-sm font-medium text-nomad-300 transition-colors hover:text-nomad-accent">
            <span class="icon-chevron-left transition-transform group-hover:-translate-x-0.5"></span> All stories
        </Link>
        <header class="grid gap-4">
            <span v-if="story.source" class="nl-eyebrow">{{ story.source.name }}</span>
            <h1 class="nl-title text-3xl leading-tight lg:text-5xl" v-html="story.title"></h1>
            <div class="text-sm text-nomad-400">
                <span v-if="story.author" class="text-nomad-200">{{ story.author }}</span>
                <span v-if="story.author" class="mx-2">·</span>{{ story.published_at }}
            </div>
            <a href="https://google.com/preferences/source?q=nomadlyrics.com" class="nl-btn-ghost w-fit" target="_blank">
                <span class="icon-plus-circle text-nomad-accent"></span> Add Heesify on Google
            </a>
        </header>
        <img v-if="story.image" :src="story.image" class="w-full rounded-2xl ring-1 ring-white/[0.08]" alt="">

        <div class="grid gap-5">
            <div v-for="(block, index) in story.blocks" :key="index">
                <AdSlot v-if="index === 3" placement="article" class="my-4" />
                <p v-if="block.type == 'paragraph'" class="break-words text-lg leading-8 text-nomad-100" v-html="block.data.text"></p>
                <div v-if="block.type == 'heading'" class="mt-4 font-display text-2xl font-semibold text-white" v-html="block.data.text"></div>
                <figure v-if="block.type == 'image'" class="grid gap-2">
                    <img :src="block.data.url" :alt="block.data.text" class="rounded-2xl">
                    <figcaption class="text-sm text-nomad-400" v-html="block.data.text"></figcaption>
                </figure>
            </div>
        </div>
        <AdSlot placement="article" />
        <div v-if="story.source" class="border-t border-white/[0.06] pt-6 text-sm">
            <a :href="story.source_article" target="_blank" class="inline-flex items-center gap-1.5 text-nomad-300 transition-colors hover:text-nomad-accent">
                Read on {{ story.source.name }} <span class="icon-external-link"></span>
            </a>
        </div>
    </article>
</template>
<script setup>
import AdSlot from "@/components/ui/AdSlot.vue";
import { Link, usePage, router } from "@inertiajs/vue3";
const { story } = usePage().props;
</script>